import { EXTERNAL_LOYALTY_PARTNERS } from "../../data/constants/shared";
import { defineProfile } from "./defaultProfile";

/**
 * Bluetokai — an external partner with a MEMBERSHIP model rather than a spendable balance. Legacy
 * **class 2**.
 *
 * 🔴 **Points redemption is off entirely.** The POS shows no redemption panel for this provider
 * regardless of what balance the API returns or how the merchant is configured — the partner's
 * value to a customer is their circle membership, not points off a bill.
 *
 * What it does surface is that membership: `loyaltyInfo.circleStatus` ("Member", "Eligible",
 * "Not Eligible", "Declined"), rendered as a badge on the customer form.
 *
 * Its COUPON behaviour — and it is the most interesting of the three — is declared in
 * `packages/core/discounts/providers/bluetokai.ts`.
 */
export const bluetokaiProfile = defineProfile(EXTERNAL_LOYALTY_PARTNERS.BLUETOKAI, {
  supportsPointsRedemption: false,
  membershipStatusField: "circleStatus",
});
